import { WebStorageStateStore } from "oidc-client-ts";
import { AMAZON_FEDERATE_PROD, ENV } from "../utils/detectEnv";

const getClientId = (): string => {
  const host = window.location.host;
  if (host.includes(ENV.LOCAL) || host.includes(ENV.BETA)) {
    return "WHS-Saige-Integration-Test";
  }
  return "WHS-Safer-Saige";
};

export const getOidcConfig = () => {
  const authority = AMAZON_FEDERATE_PROD;

  return {
    authority,
    client_id: getClientId(),
    redirect_uri: "https://gamma.in.safer.whs.amazon.dev/idpresponse",
    silent_redirect_uri: "https://gamma.in.safer.whs.amazon.dev/silent-callback.html",
    response_type: "code",
    scope: "openid profile email",
    automaticSilentRenew: false,
    silentRequestTimeoutInSeconds: 3,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  };
};
